import React from "react";
import { css } from "styled-components";
import { Icon } from "antd";
import { Link } from "react-router-dom";

const styles = {
    topbarLeftContainer: css`
        display: flex;
        width: 100%;
    `,
    topbarBackLink: css`
        min-width: 6em;
        margin-top: 0.6em;
    `,
};

export const BackButtonTopbar = ({ children, link }) => (
    <div css={styles.topbarLeftContainer}>
        <div css={styles.topbarBackLink}>
            <Icon type="left" theme="outlined" />
            <Link to={link}>BACK</Link>
        </div>
        {children}
    </div>
);
